#import "@/apollo/fragments/Job.gql"

query LastJobByCampaignId($campaignId: String!) {
    getLastJobByCampaignId(campaignId: $campaignId) {
        job {
            ...Job
        }
        feed
    }
}
